import React from 'react';
import logComponent from '../../common/logComponent';

export default function NewPanel({ children }) {
  if (logComponent('NewPanel')) { console.debug('NewPanel rendered'); }

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
}